
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'

import { mapGetters, mapActions } from 'vuex';
export default {
components: { ViewBox, Tabbar },
name: 'app',
data() {
return {
selected: '',
aa: '',
transitionName: 'slide-left',
linkArr: [
{ name: '页面滚动', url: '#/', navName: '页面滚动', act: true },
{
name: '功能列表',
url: '#/squareCurriculum',
navName: '功能列表',
act: false
},
{
name: '我的课程',
url: '#/myCurriculum',
navName: '我的课程',
act: false
},
{ name: '个人中心', url: '#/center', navName: '个人中心', act: false }
]
};
},
methods: {
...mapActions([]),
getNavName() {
for (let i = 0; i < this.linkArr.length; i++) {
if (this.linkArr[i].navName === this.navbarText) {
this.linkArr[i].act = true;
} else {
this.linkArr[i].act = false;
}
}
}
},
watch: {
navbarText() {
this.getNavName();
}
},
computed: {
...mapGetters(['showtabbar', 'tabberSwite', 'navbarText'])
},
created() {
this.getNavName();
},
mounted() { }
};
